import { render, staticRenderFns } from "./user_background_jobs.vue?vue&type=template&id=0222df9f&scoped=true"
import script from "./user_background_jobs.vue?vue&type=script&lang=js"
export * from "./user_background_jobs.vue?vue&type=script&lang=js"
import style0 from "./user_background_jobs.vue?vue&type=style&index=0&id=0222df9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0222df9f",
  null
  
)

export default component.exports